import { Proforma } from '@arpada/arp-lib-common-qupro';
import { ProformaStateFront } from './api.dto';

export class ProformaFront extends Proforma {

    proformaState: ProformaStateFront;
}
